<template>
    <div class="bg-white rounded-lg p-3 text-center color-main font-bold">
        <div class="text-xl">
            Chúng tôi đang tiếp tục tìm kiếm khoản vay cho bạn
        </div>
        <div class="grid grid-cols-7 m-auto text-center gap-4 mt-4">
            
            <div class="col-span-4">
                <img class="h-10" src="@/assets/default/shbfinance3.png" >
            </div>
                <div class="col-span-3">
                <img class="h-10" src="@/assets/default/tpfico3.jpg" >
                
            </div>
        </div>
        <div class="grid grid-cols-7 m-auto text-center gap-4 mt-4">
            
            <div class="col-span-4">
                <img class="h-10" src="@/assets/default_main/mcredit.png" >
            </div>

            <div class="col-span-3">
                <img class="h-10" src="@/assets/default/tima.png" >
            </div>
        </div>
        
        
    </div>
</template>

<script>
export default {

}
</script>

<style>

</style>